import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=cc06bfd0&scoped=true"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=cc06bfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc06bfd0",
  null
  
)

export default component.exports